import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox, Stack } from '@ardoq/layout';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { updateViewSettings } from '@ardoq/view-settings';
import { t, Trans, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

type NoTagsWithSettingsDoqProps = {
  doqType: DoqType;
  viewId: string;
  includeActions?: boolean;
  i18nLocale: I18nLocale;
};

const NoTagsWithSettingsDoqBase = ({
  doqType,
  viewId,
  includeActions = true,
  i18nLocale,
}: NoTagsWithSettingsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noTagsWithSettings.title',
          'There is nothing to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noTagsWithSettings.message1',
                'Workspace does not have any used tags.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              <span style={{ display: 'inline' }}>
                <Trans
                  i18nKey="tabview:graphViews.emptyState.noTagsWithSettings.message2"
                  defaults='To show more data, deactivate the view modifier "<icon/>"'
                  components={{
                    icon: (
                      <Icon iconSize={IconSize.SMALL} iconName={IconName.TAG} />
                    ),
                  }}
                />
              </span>
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions
            ? t(
                i18nLocale,
                'tabview:graphViews.emptyState.noTagsWithSettings.deactivateSetting',
                'Deactivate setting'
              )
            : undefined
        }
        onButtonClick={
          includeActions
            ? () =>
                dispatchAction(
                  updateViewSettings({
                    viewId,
                    settings: { excludeUnused: false },
                    persistent: true,
                  })
                )
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoTagsWithSettingsDoq = connect(
  NoTagsWithSettingsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
